// AppConfigService for managing app-wide config such as header visibility

type AppConfig = {
  headerVisible: boolean;
};

const APP_CONFIG_KEY = "AppConfig";

function getDefaultConfig(): AppConfig {
  return {
    headerVisible: true,
  };
}

export function getAppConfig(): AppConfig {
  const config = localStorage.getItem(APP_CONFIG_KEY);
  return config ? JSON.parse(config) : getDefaultConfig();
}

export function setAppConfig(config: Partial<AppConfig>) {
  const current = getAppConfig();
  const updated = { ...current, ...config };
  localStorage.setItem(APP_CONFIG_KEY, JSON.stringify(updated));
}

export function setHeaderVisible(headerVisible: boolean) {
  setAppConfig({ headerVisible });
}
